import React, {useEffect, useMemo, useState} from 'react';
import {
    MaterialReactTable,
    MRT_GlobalFilterTextField,
    MRT_ToggleFiltersButton,
    MRT_ToolbarAlertBanner
} from 'material-react-table';
import {MRT_Localization_RU} from "material-react-table/locales/ru";
import {Link, useNavigate} from "react-router-dom";
import MaterialWarehouseService from "../../../../../../API/orders/warehouse/material/MaterialWarehouseService";
import DateTimeUtil from "../../../../../../utils/common/DateTimeUtil";
import DateRangeFilter from "../../../../filter/DateRangeFilter";
import PriceWithCurrency from "../PriceWithCurrency";
import FilterUtil from "../../../../../../utils/common/FilterUtil";
import CellCheckbox from "../../../../сheckbox/CellCheckbox";
import CellCheckboxAMPUTFixPrice from "../arrival/CellCheckboxAMPUTFixPrice";
import {Dialog, DialogActions, DialogContent, DialogTitle, Stack} from "@mui/material";
import Box from "@mui/material/Box";
import ModalAddWarehouseMaterial from "./ModalAddWarehouseMaterial";
import ButtonCreate from "../../../../button/ButtonCreate";
import MenuItem from "@mui/material/MenuItem";
import TextFieldValidation from "../../../customer-detales/TextFieldValidation";
import ButtonExit from "../../../../button/ButtonExit";
import ButtonAdd from "../../../../button/ButtonAdd";
import {materialWarehouseStatuses} from "../../../../../../data/MaterialWarehouseState";
import ModalConfirm from "../../../../modal/ModalConfirm";
import NameModal from "../../../../modal/NameModal";

const WarehouseMaterialItemTable = ({
                                        getAll,
                                        id,
                                        materialId,
                                        baseUnit,
                                        typeMaterial,
                                        material,
                                        currencyMap,
                                        tableOptions,
                                        tableOptionsHandle,
                                        currencies,
                                        handleModalAlert,
                                        isArchive,
                                        readOnly,
                                        childrenId,
                                        isModal,
                                        selectedString,
                                        setSelectedString
                                    }) => {

    const [data, setData] = useState([]);
    const [isFullScreen, setIsFullScreen] = useState(false);

    const [modalAddWarehouseMaterial, setModalAddWarehouseMaterial] = useState(false);
    const nameMaterial = material ? material?.name : null;
    const isTypeMaterial = material ? material.typeMaterial === "SLAB" : false;

    const [supplierMaterials, setSupplierMaterials] = useState()
    const [dataSuppliers, setDataSuppliers] = useState()
    const [modal, setModal] = useState(false);
    const [currentEditRowData, setCurrentEditRowData] = useState({id: "", price: "", currencyId: ""})

    const navigate = useNavigate();

    const profile = JSON.parse(localStorage.getItem("profile"))
    const [baseCurrency, setBaseCurrency] = useState(profile?.baseCurAbbreviation);
    const [alternativeCurrency, setAlternativeCurrency] = useState(profile?.alternativeCurAbbreviation);

    const [confirmModalOpen, setConfirmModalOpen] = useState(false);
    const [issueModalOpen, setIssueModalOpen] = useState(false);
    const [noteModalOpen, setNoteModalOpen] = useState(false);
    const [noteFormState, setNoteFormState] = useState({note: ""});
    const [isDelete, setIsDelete] = useState(false);
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        getAll(childrenId || id).then(function (response) {
            setData(response.data);
            tableOptionsHandle({...tableOptions, totalElements: response.data?.length}, 3)
        })
            .catch(function (error) {
                handleModalAlert(error);
            });

    }, []);

    const sumTotalIssued = useMemo(
        () => data.reduce((acc, mEU) => acc + mEU.totalIssued, 0),
        [data]
    );

    const sumInReserve = useMemo(
        () => data.reduce((acc, mEU) => acc + mEU.inReserve, 0),
        [data]
    );

    const sumFreeQuantity = useMemo(
        () => data.reduce((acc, mEU) => acc + mEU.freeQuantity, 0),
        [data]
    );

    const sumQuantity = useMemo(
        () => data.reduce((acc, mEU) => acc + mEU.quantity, 0),
        [data]
    );
    const sumMaterialPriceUnit = useMemo(
        () => data.reduce((acc, mEU) => acc + mEU.materialPriceUnit.quantity, 0),
        [data]
    );

    const sumArrivalAmountBasePrice = useMemo(
        () => data.reduce((acc, mEU) => acc + mEU.arrivalAmountBasePrice, 0),
        [data]
    );

    const sumArrivalAmountAlternativePrice = useMemo(
        () => data.reduce((acc, mEU) => acc + mEU.arrivalAmountAlternativePrice, 0),
        [data]
    );

    const sumAmountBasePrice = useMemo(
        () => data.reduce((acc, mEU) => acc + mEU.amountBasePrice, 0),
        [data]
    );

    const sumAmountAlternativePrice = useMemo(
        () => data.reduce((acc, mEU) => acc + mEU.amountAlternativePrice, 0),
        [data]
    );

    const handleCreateNewRow = (values) => {
        data.push(values);
        setData([...data]);
    };

    const handleSubmitCreate = (data, reset) => {
        setLoading(true)
        const materialWarehouseData = {
            materialPriceUnit: data.materialPriceUnit,
            note: data.note
        }

        const supplierMaterialId = data.supplierMaterialId;

        MaterialWarehouseService.createPlanned(materialWarehouseData, nameMaterial, supplierMaterialId)
            .then(function (response) {
                const responseData = response.data;
                handleCreateNewRow(responseData)
                reset();
                handleModalAlert("Плановая закупка добавлена", 'success')
            })
            .catch(function (error) {
                handleModalAlert(error);
            }).finally(() => setLoading(false))
    }

    const handleClose = () => {
        setModalAddWarehouseMaterial(false)
        setModal(false)
        setCurrentEditRowData({id: "", price: "", currencyId: ""})
    }

    const handleAddWarehouseMaterial = () => {
        setModalAddWarehouseMaterial(true)
    };

    const handleSubmit = (data) => {
        setLoading(true)
        MaterialWarehouseService.setPriceCloud(data.id, data.currencyId, data.price)
            .then(function (response) {
                setData(prev => prev.map(el => el.id === data.id ? response.data : el))
                handleModalAlert("Цена продажи изменена", 'success')
            })
            .catch(function (error) {
                handleModalAlert(error);
            }).finally(() => setLoading(false))
    }
    const handleAdd = (row) => {
        setModal(true)
        setCurrentEditRowData({
            id: row.id,
            price: row.materialWarehouseCloudMarketPrice?.price,
            currencyId: row.materialWarehouseCloudMarketPrice?.currencyId || (currencies && currencies[0]?.id)
        })
    }
    const handleDeletePlanned = (row) => {
        setConfirmModalOpen(true);
        setCurrentEditRowData(row)
        setIsDelete(true)
    }
    const handleToArchive = (row) => {
        setCurrentEditRowData(row);
        setConfirmModalOpen(true);
        setIsDelete(false)
    }
    const handleSetToIssue = (row) => {
        setCurrentEditRowData(row);
        setIssueModalOpen(true);
    }
    const handleEditNote = (row) => {
        setCurrentEditRowData(row);
        setNoteFormState({note: row.note ?? ""});
        setNoteModalOpen(true);
    };
    const handleCloseNoteModal = () => {
        setNoteModalOpen(false);
        setCurrentEditRowData(null);
        setNoteFormState({note: ""});
    };
    const handleSubmitNote = () => {
        setLoading(true);
        MaterialWarehouseService.saveNote(currentEditRowData.id, noteFormState.note ?? "")
            .then(function (response) {
                const submittedNote = noteFormState.note ?? "";
                const updatedNote = response.data == null || response.data === ""
                    ? submittedNote
                    : (typeof response.data === "string"
                        ? response.data
                        : (response.data?.note ?? submittedNote));
                setData(prev => prev.map(el => el.id === currentEditRowData.id ? {
                    ...el,
                    note: updatedNote,
                } : el));
                handleModalAlert("Комментарий изменён", 'success');
                handleCloseNoteModal();
            })
            .catch(function (error) {
                handleModalAlert(error);
            })
            .finally(() => setLoading(false));
    };

    const handleCloseConfirm = () => {
        setConfirmModalOpen(false);
        setCurrentEditRowData(null)
    };
    const setToIssue = ({name}) => {
        MaterialWarehouseService.sendToIssue(currentEditRowData?.id, name || null)
            .then(function () {
                setData(prev => prev.filter(el => currentEditRowData?.id !== el.id))
                tableOptionsHandle({...tableOptions, totalElements: data?.length - 1})
                handleModalAlert("Материал списан", 'success')
                setIssueModalOpen(false)
                setCurrentEditRowData(null)
            })
            .catch(function (error) {
                handleModalAlert(error);
            })
    }
    const handleSubmitConfirm = () => {
        if (isDelete) {
            MaterialWarehouseService.deletePlanned(currentEditRowData?.id)
                .then(function () {
                    handleCloseConfirm()
                    setData(prev => prev.filter(el => currentEditRowData?.id !== el.id))
                    tableOptionsHandle({...tableOptions, totalElements: data?.length - 1})
                    handleModalAlert("Данные удалены", 'success')
                })
                .catch(function (error) {
                    handleModalAlert(error);
                })
        } else {
            MaterialWarehouseService.sendToArchive(currentEditRowData?.id)
                .then(function () {
                    handleCloseConfirm()
                    setData(prev => prev.filter(el => currentEditRowData?.id !== el.id))
                    tableOptionsHandle({...tableOptions, totalElements: data?.length - 1})
                    handleModalAlert("Данные отправлены в архив", 'success')
                })
                .catch(function (error) {
                    handleModalAlert(error);
                })
        }
    };

    const handleDelete = (row) => {
        const id = row.id;
        MaterialWarehouseService.delete(id)
            .then(function () {
                setData(prev => prev.map(el => el.id === id ? {
                    ...el,
                    materialWarehouseCloudMarketPrice: null
                } : el))
                handleModalAlert("Данные удалены", 'success')
            })
            .catch(function (error) {
                handleModalAlert(error);
            })
    }

    const redirectArchive = () => {
        const name = encodeURIComponent(nameMaterial);
        navigate(`/organization/materials/${id}/${baseUnit}/${typeMaterial}/${materialId}/warehouse-material/archive/${name}`);
    };

    const columns = useMemo(() => {
        const baseColumns = [
            {
                accessorFn: (row) => {
                    if (row.dateTime === null) {
                    } else {
                        return new Date(row.dateTime)
                    }
                },
                id: 'dateTime',
                header: 'Приход',
                sortingFn: 'dateTime',
                size: 130,
                Cell: ({cell, row}) => (
                    cell.getValue() !== undefined && cell.getValue() !== null ? (
                        <li key={cell.getValue()}>
                            <Link
                                to={'/organization/materials-price-unit-arrival-item/reserve-warehouse/' + row.original.materialPriceUnit.id + '/'
                                    + typeMaterial + '/' + baseUnit + '/' + id + '/' + materialId + '/' + encodeURIComponent(nameMaterial) + "/" + readOnly}>
                                {DateTimeUtil.dateTimeToString(cell.getValue())}
                            </Link>
                        </li>
                    ) : ""
                ),

                filterFn: (row, id, filterValue) => {
                    const startDate = filterValue?.startDate;
                    const endDate = filterValue?.endDate;
                    if (startDate && endDate) {
                        return (
                            DateTimeUtil.checkDateBefore(row.getValue(id), startDate) &&
                            DateTimeUtil.checkDateAfter(row.getValue(id), endDate)
                        );
                    }
                    return true;
                },
                Filter: ({column}) => <DateRangeFilter
                    column={column}
                />,
            },
            {
                id: 'materialPriceUnit',
                header: `Приход  ${baseUnit}`,
                accessorKey: 'materialPriceUnit.quantity',
                size: 80,
                Cell: ({cell}) => {
                    const value = cell.getValue();
                    return value === null || value === undefined ? 'Ожидание' : value.toFixed(3)
                },
                Footer: () => (
                    <Stack>
                        <Box color="warning.main">
                            {sumMaterialPriceUnit?.toLocaleString?.('en-US', {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 3,
                            })}
                        </Box>
                    </Stack>
                ),
            },
            {
                id: 'quantity',
                header: `Наличие ${baseUnit}`,
                accessorKey: 'quantity',
                size: 3,
                maxSize: 3,
                Cell: ({row}) => row.original.quantity?.toFixed(3),
                Footer: () => (
                    <Stack>
                        <Box color="warning.main">
                            {sumQuantity?.toLocaleString?.('en-US', {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 3,
                            })}
                        </Box>
                    </Stack>
                ),
            },
            {
                id: 'totalIssued',
                header: `Выдано`,
                accessorKey: 'totalIssued',
                size: 3,
                maxSize: 3,
                Cell: ({cell, row}) => {
                    const value = cell.getValue();
                    return isModal ? value.toFixed(3) : <Link
                        to={'/organization/issuance-warehouse-material/' + row.original.id}>{value === null || value === undefined ? "0.000" : value.toFixed(3)}</Link>
                },
                Footer: () => (
                    <Stack>
                        <Box color="warning.main">
                            {sumTotalIssued?.toLocaleString?.('en-US', {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 3,
                            })}
                        </Box>
                    </Stack>
                ),
            },
            {
                id: 'inReserve',
                header: `В резерве`,
                accessorKey: 'inReserve',
                size: 3,
                maxSize: 3,
                Cell: ({cell, row}) => (
                    isModal ? row.original.inReserve.toFixed(3) : <Link
                        to={'/organization/materials/' + id + '/' + baseUnit + '/' + typeMaterial + '/' + materialId + '/' + encodeURIComponent(nameMaterial) + '/reserve-warehouse/' + row.original.id}>{row.original.inReserve?.toFixed(3)}</Link>
                ),
                Footer: () => (
                    <Stack>
                        <Box color="warning.main">
                            {sumInReserve?.toLocaleString?.('en-US', {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 3,
                            })}
                        </Box>
                    </Stack>
                ),
            },
            {
                id: 'freeQuantity',
                header: `Свободно`,
                accessorKey: 'freeQuantity',
                size: 3,
                maxSize: 3,
                Cell: ({row}) => row.original.freeQuantity?.toFixed(3),
                Footer: () => (
                    <Stack>
                        <Box color="warning.main">
                            {sumFreeQuantity?.toLocaleString?.('en-US', {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 3,
                            })}
                        </Box>
                    </Stack>
                ),
            },
            {
                id: 'arrivalAmountBasePrice',
                header: `Сумма прихода в ${baseCurrency}`,
                accessorKey: 'arrivalAmountBasePrice',
                size: 8,
                maxSize: 8,
                enableEditing: false,
                Cell: ({row}) => row.original.arrivalAmountBasePrice?.toFixed(3),
                Footer: () => (
                    <Stack>
                        <Box color="warning.main">
                            {sumArrivalAmountBasePrice?.toLocaleString?.('en-US', {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 3,
                            })} {baseCurrency}
                        </Box>
                    </Stack>
                ),
            },
            {
                id: 'arrivalAmountAlternativePrice',
                header: `Сумма прихода в ${alternativeCurrency}`,
                accessorKey: 'arrivalAmountAlternativePrice',
                size: 8,
                maxSize: 8,
                enableEditing: false,
                Cell: ({row}) => row.original.arrivalAmountAlternativePrice?.toFixed(3),
                Footer: () => (
                    <Stack>
                        <Box color="warning.main">
                            {sumArrivalAmountAlternativePrice?.toLocaleString?.('en-US', {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 3,
                            })} {alternativeCurrency}
                        </Box>
                    </Stack>
                ),
            },
            {
                id: 'amountBasePrice',
                header: `Сумма в ${baseCurrency}`,
                accessorKey: 'amountBasePrice',
                size: 8,
                maxSize: 8,
                enableEditing: false,
                Cell: ({row}) => row.original.amountBasePrice?.toFixed(3),
                Footer: () => (
                    <Stack>
                        <Box color="warning.main">
                            {sumAmountBasePrice?.toLocaleString?.('en-US', {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 3,
                            })} {baseCurrency}
                        </Box>
                    </Stack>
                ),
            },
            {
                id: 'amountAlternativePrice',
                header: `Сумма в ${alternativeCurrency}`,
                accessorKey: 'amountAlternativePrice',
                size: 8,
                maxSize: 8,
                enableEditing: false,
                Cell: ({row}) => row.original.amountAlternativePrice?.toFixed(3),
                Footer: () => (
                    <Stack>
                        <Box color="warning.main">
                            {sumAmountAlternativePrice?.toLocaleString?.('en-US', {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 3,
                            })} {alternativeCurrency}
                        </Box>
                    </Stack>
                ),
            },
            {
                id: 'PriceInCurrencyArrival',
                header: 'Цена в валюте прихода',
                accessorKey: 'materialPriceUnit.materialPriceInCurrencyArrival.price',
                size: 250,
                enableEditing: false,
                Cell: ({cell, row}) => <
                    PriceWithCurrency cell={cell}
                                      row={row}
                                      currencyMap={currencyMap}
                />,
            },
            {
                id: 'PriceInCurrencyBase',
                header: `Цена в ${baseCurrency}`,
                accessorKey: 'materialPriceUnit.materialPriceInCurrencyBase.price',
                size: 8,
                maxSize: 8,
                enableEditing: false,
                Cell: ({row}) => row.original.materialPriceUnit.materialPriceInCurrencyBase?.price?.toFixed(3),
            },
            {
                id: 'PriceInCurrencyAlternative',
                header: `Цена в ${alternativeCurrency}`,
                accessorKey: 'materialPriceUnit.materialPriceInCurrencyAlternative.price',
                size: 8,
                maxSize: 8,
                enableEditing: false,
                Cell: ({row}) => row.original.materialPriceUnit.materialPriceInCurrencyAlternative?.price?.toFixed(3),
            },
            {
                id: 'coefficientCurrencyBasePrice',
                header: `Кф. курса б.цены`,
                accessorKey: 'materialPriceUnit.coefficientCurrencyBasePrice',
                size: 8,
                maxSize: 8,
                enableEditing: false,
                Cell: ({row}) => row.original.materialPriceUnit.coefficientCurrencyBasePrice?.toFixed(3),
            },
            {
                id: 'basePrice',
                header: 'Баз. цена',
                accessorKey: 'basePrice.price',
                size: 8,
                Cell: ({row}) => {
                    const basePrice = row.original.materialPriceUnit.materialPriceInRealBasePrice || null;
                    return basePrice === null ? '' : (<CellCheckboxAMPUTFixPrice
                        price={basePrice}
                        fixPrice={row.original.materialPriceUnit.materialPriceInRealBasePrice.fixPrice}
                        currencyMap={currencyMap}
                    />);
                }, minSize: 8, maxSize: 8,
            },
            {
                id: 'materialWarehouseCloudMarketPrice',
                header: `Цена продажи`,
                accessorFn: (row) => row.materialWarehouseCloudMarketPrice && `${row.materialWarehouseCloudMarketPrice?.price} ${currencies?.find(el => el.id === row.materialWarehouseCloudMarketPrice?.currencyId)?.curAbbreviation}`,
                size: 8,
                maxSize: 8,
                enableEditing: false,
                Cell: ({row}) => row.original.materialWarehouseCloudMarketPrice && `${row.original.materialWarehouseCloudMarketPrice?.price?.toFixed(3)} ${currencies?.find(el => el.id === row.original.materialWarehouseCloudMarketPrice?.currencyId)?.curAbbreviation}`,
            },
            {
                id: 'materialWarehouseState',
                header: 'Статус',
                accessorKey: 'materialWarehouseState',
                size: 8,
                maxSize: 8,
                Cell: ({cell}) => materialWarehouseStatuses[cell.getValue()],
                filterFn: (row, id, filterValue) => {
                    return materialWarehouseStatuses[row.original.materialWarehouseState].toLowerCase().includes(filterValue.toLowerCase())
                },
            },
            {
                id: 'totalWrittenOff',
                header: 'Списано',
                accessorKey: 'totalWrittenOff',
                size: 8,
                maxSize: 8,
                enableEditing: false,
            },
            {
                id: 'warehouse',
                header: 'Склад',
                accessorKey: 'warehouse.name',
                size: 8,
                maxSize: 8,
                enableEditing: false,
            },
            {
                id: 'supplier',
                header: 'Поставщик',
                accessorKey: 'materialPriceUnit.supplierMaterial.supplier.name',
                size: 180,
            },
            {
                header: 'id',
                id: 'id',
                accessorKey: 'id',
                enableColumnActions: false,
                enableGrouping: false,
                enableEditing: false,
                enableHiding: false,
            },
            {
                id: 'workingCuttingMap',
                header: `Карта`,
                accessorKey: 'workingCuttingMap',
                size: 3,
                maxSize: 3,
                Cell: ({ cell, row }) => {
                    const workingCuttingMap = row.original.workingCuttingMap;
                    const materialPriceUnit = row.original.materialPriceUnit;

                    if (!materialPriceUnit?.cutOff) {
                        return "";
                    }

                    if (!workingCuttingMap) {
                        return "";
                    }

                    return (
                        <Link
                            to={`/organization/working-cutting-map/${workingCuttingMap.id}/${encodeURIComponent(nameMaterial)}/${workingCuttingMap.number}/${id}`}
                        >
                            {workingCuttingMap.number}
                        </Link>
                    );
                },

                Footer: () => (
                    <Stack>
                        <Box color="warning.main">
                            {sumInReserve?.toLocaleString?.('en-US', {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 3,
                            })}
                        </Box>
                    </Stack>
                ),
            },
        ];

        const noteColumn = {
            id: 'note',
            header: 'Комментарий',
            accessorKey: 'note',
            size: 100,
            Cell: ({cell}) => cell.getValue() ?? '',
        };

        if (typeMaterial === 'SLAB') {
            baseColumns.splice(0, 0, {
                id: 'length',
                header: 'Ширина',
                accessorKey: 'materialPriceUnit.length',
                minSize: 15,
                maxSize: 15,
            });
        }

        if (typeMaterial === 'SLAB') {
            baseColumns.splice(1, 0, {
                id: 'width',
                header: 'Высота',
                accessorKey: 'materialPriceUnit.width',
                minSize: 15,
                maxSize: 15,
            });
        }

        if (typeMaterial === 'SLAB') {
            baseColumns.splice(2, 0, {
                id: 'cutOff',
                header: 'Обрезок',
                accessorKey: 'materialPriceUnit.cutOff',
                size: 8,
                enableEditing: false,
                filterVariant: 'multi-select',
                filterSelectOptions: FilterUtil.statusList,
                filterFn: (row, id, filterValue) => {
                    return FilterUtil.checkStatus(row.getValue(id), filterValue)
                },
                Cell: ({cell}) => <CellCheckbox
                    cell={cell}
                    disabled={true}
                />,
            });
            baseColumns.splice(3, 0, noteColumn);
            if (typeMaterial === 'SLAB') {
                baseColumns.splice(8, 0, {
                    id: 'inCutOff',
                    header: `В обрезках`,
                    accessorKey: 'inCutOff',
                    size: 3,
                    maxSize: 3,
                    Cell: ({cell, row}) => {
                        const value = cell.getValue();
                        return <Link
                            to={`/organization/materials/${id}/${baseUnit}/${typeMaterial}/${materialId}/${encodeURIComponent(nameMaterial)}/children/${row.original.id}`}>{value?.toFixed(3)}</Link>
                    },
                },);
            }
        } else {
            baseColumns.splice(0, 0, noteColumn);
        }

        return baseColumns;

    }, [data, setData, baseCurrency, alternativeCurrency, typeMaterial, baseUnit, nameMaterial]);

    const menuItem = [
        {type: "deletePlanned", text: "Удалить", handler: handleDeletePlanned},
        {type: "add", text: "Добавить цену продажи", handler: handleAdd},
        {type: "delete", text: "Удалить цену продажи", handler: handleDelete},
        {type: "editNote", text: "Изменить комментарий", handler: handleEditNote},
        {type: "archive", text: "Поместить в архив", handler: handleToArchive},
        {type: "setToIssue", text: "Списать", handler: handleSetToIssue}]

    return (
        <div>
            <Box
                sx={{display: 'flex', justifyContent: "flex-end", paddingBottom: "30px", gap: "10px"}}
            >
                {isTypeMaterial && !readOnly && !isModal && <ButtonCreate
                    text={"Добавить плановый"}
                    onClick={handleAddWarehouseMaterial}
                    width={220}
                >
                </ButtonCreate>}
                {(!isArchive && !childrenId) && !isModal && <ButtonCreate
                    text={"Архив"}
                    onClick={redirectArchive}
                    icon={false}
                    width={60}
                >
                </ButtonCreate>}
            </Box>
            <MaterialReactTable
                renderTopToolbar={({table}) => {
                    return <Box sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        padding: "7px",
                        backgroundColor: (theme) => table.getSelectedRowModel().rows.length > 0 ? theme.palette.primary.light : "transparent",
                    }}>
                        <MRT_ToolbarAlertBanner table={table}/>
                        <Box sx={{display: "flex"}}>
                            <MRT_ToggleFiltersButton table={table}/>
                            <MRT_GlobalFilterTextField table={table}/>
                        </Box>
                    </Box>
                }}
                muiTableBodyCellProps={{
                    sx: {
                        p: '0px 0px 0px 10px',
                        m: '0px 0px 0px 0px',
                        border: "none",
                        "&:after": {
                            display: "none",
                        },
                        "& td:after": {
                            "&:hover": {
                                backgroundColor: "red"
                            }
                        },
                        "&:not(:last-of-type)": {
                            borderRight: '1px solid #EAEBEA',

                        },
                        "&:first-of-type": (!isArchive && !readOnly && !childrenId && !isModal) && {
                            padding: 0,
                            width: "50px",
                            height: "36px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            color: (theme) => theme.palette.text.light,
                            "& .MuiButtonBase-root": {
                                borderRadius: "4px",
                                width: "24px",
                                height: "24px",
                                opacity: 1,
                                margin: 0,
                                padding: 0,
                                "&:hover": {
                                    backgroundColor: (theme) => theme.palette.primary.stroke,
                                }
                            }
                        },
                        "& a": {
                            color: "#006CCC",
                            textDecoration: "none",
                            "&:hover": {
                                textDecoration: "underline"
                            }
                        }
                    },
                }}
                muiTableHeadCellProps={{
                    sx: {
                        border: '1px solid #EAEBEA',
                        backgroundColor: "#F5F6FA",
                        padding: "10px",
                        paddingBottom: " 0.2rem",
                        paddingTop: "0.2rem"
                    },
                }}
                muiTableBodyRowProps={({row}) => {
                    return ({
                        onClick: () => isModal && setSelectedString(row.original),
                        sx: () => ({
                            height: '36px',
                            cursor: isModal && "pointer",
                            "&:hover& td:after": {
                                display: "none",
                            },
                            '&:nth-of-type(even)': {
                                backgroundColor: row.original.id === selectedString?.id ? (theme) => theme.palette.primary.light : (theme) => theme.palette.primary.lightGrey,
                                "&.MuiTableRow-root.Mui-selected": {
                                    backgroundColor: (theme) => theme.palette.primary.light,
                                    "&:hover": {
                                        backgroundColor: (theme) => theme.palette.primary.light50,
                                    },
                                },
                                "&:hover": {
                                    backgroundColor: row.original.id === selectedString?.id ? (theme) => theme.palette.primary.light50 : (theme) => theme.palette.primary.stroke,
                                },
                            },
                            backgroundColor: row.original.id === selectedString?.id ? (theme) => theme.palette.primary.light : "white",
                            "&:hover": {
                                backgroundColor: row.original.id === selectedString?.id ? (theme) => theme.palette.primary.light50 : (theme) => theme.palette.primary.stroke,
                            },
                            "&.MuiTableRow-root.Mui-selected": {
                                backgroundColor: (theme) => theme.palette.primary.light70,
                                "&:hover": {
                                    backgroundColor: (theme) => theme.palette.primary.light50,
                                },
                            },
                        })
                    })
                }}

                displayColumnDefOptions={{
                    'mrt-row-actions': {
                        header: "",
                        size: 3,
                        minSize: 3,
                        grow: false,
                    },
                }}
                muiSearchTextFieldProps={{
                    placeholder: `Поиск`,
                    sx: {
                        paddingTop: "5px",
                        paddingBottom: "0px",
                        "& .MuiCollapse-root": {
                            borderRadius: '12px',
                            height: 40, width: 290,
                            "& .MuiSvgIcon-root": {
                                color: "#737478"
                            },
                            '& .MuiOutlinedInput-input': {
                                padding: 0
                            }
                        }
                    },
                    variant: 'outlined',
                }}
                isFullScreen={isFullScreen}
                columns={columns}
                data={data}
                initialState={{
                    columnVisibility: {
                        id: false,
                        coefficientCurrencyBasePrice: !isModal,
                        basePrice: !isModal,
                        materialWarehouseCloudMarketPrice: !isModal,
                        materialWarehouseState: !isModal,
                        totalWrittenOff: !isModal,
                        supplier: !isModal,
                        note: !isModal,
                        arrivalAmountBasePrice: !isModal,
                        arrivalAmountAlternativePrice: !isModal,
                        amountBasePrice: !isModal,
                        amountAlternativePrice: !isModal,
                        PriceInCurrencyArrival: !isModal,
                        PriceInCurrencyBase: !isModal,
                        PriceInCurrencyAlternative: !isModal,
                        materialPriceUnit: !isModal,
                        dateTime: !isModal,
                        warehouse: !isModal,
                    },
                    isFullScreen: false,
                    density: "compact",
                    pagination: {pageIndex: 0, pageSize: 100},
                }}
                onPaginationChange={(updater) => {
                    tableOptionsHandle(updater(tableOptions));
                }}
                renderRowActionMenuItems={({closeMenu, row}) => menuItem.map(el => {

                    return <MenuItem
                        key={el.type}
                        onClick={() => {
                            el.handler(row.original)
                            closeMenu();
                        }}
                        disabled={(el.type === "deletePlanned" && row.original.materialWarehouseState !== "PLANNED") || (el.type === "archive" && (row.original.quantity > 0 || row.original.freeQuantity > 0 || !row.original.totalIssued)) || (el.type === "setToIssue" && !row.original.quantity)}
                        sx={{
                            margin: "0 8px",
                            borderRadius: "4px",
                            "&:hover": {backgroundColor: (theme) => theme.palette.primary.light}
                        }}
                    >
                        {el.type === "add" && row.original.materialWarehouseCloudMarketPrice?.price ? "Изменить цену продажи" : el.text}
                    </MenuItem>
                })}
                state={{showGlobalFilter: true, pagination: tableOptions,}}
                rowCount={tableOptions.totalElements}
                localization={MRT_Localization_RU}
                enableRowActions={!isArchive && !readOnly && !childrenId && !isModal}
                enableToolbarInternalActions={false}
                getRowId={(originalRow) => originalRow.id}
            />

            <MaterialWarehouseCloudMarketPriceModal
                title={currentEditRowData?.price ? "Изменить цену продажи" : "Добавить цену продажи"}
                open={modal} onClose={handleClose}
                handleSubmit={handleSubmit}
                initValue={currentEditRowData}
                currencies={currencies}
                loading={loading}/>

            {modalAddWarehouseMaterial && baseCurrency !== null && alternativeCurrency !== null &&
                baseCurrency !== null && alternativeCurrency !== null
                && <ModalAddWarehouseMaterial
                    title={"Добавить плановую закупку материала"}
                    buttonName={"Добавить"}
                    open={modalAddWarehouseMaterial}
                    onClose={handleClose}
                    materialId={id}
                    materialWidth={material.width}
                    supplierMaterials={supplierMaterials}
                    setSupplierMaterials={setSupplierMaterials}
                    dataSuppliers={dataSuppliers}
                    setDataSuppliers={setDataSuppliers}
                    baseCurrency={baseCurrency}
                    alternativeCurrency={alternativeCurrency}
                    handleSubmitCreate={handleSubmitCreate}
                    currencyMap={currencyMap}
                    handleModalAlert={handleModalAlert}
                    loading={loading}
                />}
            <ModalConfirm
                title={isDelete ? "Подтвердить удаление" : "Подтвердить поместить в архив"}
                modalOpen={confirmModalOpen}
                handleClose={handleCloseConfirm}
                handleSubmit={handleSubmitConfirm}
                action={"Подтвердить"}
            />
            <NameModal
                title={"Списать"}
                label={"Комментарий"}
                open={issueModalOpen} onClose={() => setIssueModalOpen(false)}
                handleSubmit={setToIssue}
                initValue={currentEditRowData}
                loading={loading}
            />
            <Dialog open={noteModalOpen} PaperProps={{
                style: {
                    minWidth: "400px",
                    borderRadius: 8,
                },
            }}>
                <DialogTitle textAlign="center">Изменить комментарий</DialogTitle>
                <DialogContent>
                    <TextFieldValidation
                        name="note"
                        value={noteFormState.note}
                        label="Комментарий"
                        setCurrValues={setNoteFormState}
                    />
                </DialogContent>
                <DialogActions sx={{p: '1.25rem'}}>
                    <ButtonExit text={"Отменить"} onClick={handleCloseNoteModal}/>
                    <ButtonAdd loading={loading} text={"Сохранить"} onClick={handleSubmitNote}/>
                </DialogActions>
            </Dialog>
        </div>
    );
};
const MaterialWarehouseCloudMarketPriceModal = ({
                                                    open,
                                                    onClose,
                                                    handleSubmit,
                                                    initValue,
                                                    title,
                                                    currencies,
                                                    loading
                                                }) => {
    const [formState, setFormState] = useState(initValue)
    const [validationState, setValidationState] = useState({price: ""})

    useEffect(() => {
        setFormState(initValue)
    }, [open, initValue])

    const handleClose = () => {
        onClose()
    }
    const handleValidationData = () => {
        const newErrors = {...validationState}

        Object.entries(formState).forEach(([name, value]) => {
            if (value === "" || value === undefined) {
                newErrors[name] = "пустое поле"
            }
        })
        setValidationState(newErrors)
        if (Object.values(newErrors).every(el => el === "")) {
            handleSubmit(formState)
            handleClose()
        }
    }
    return (
        <Dialog open={open} PaperProps={{
            style: {
                minWidth: "400px",
                borderRadius: 8,
            }
        }}>
            <DialogTitle textAlign="center">{title}</DialogTitle>
            <DialogContent>
                <TextFieldValidation
                    name={"price"}
                    value={formState?.price}
                    type={"number"}
                    label="Цена продажи"
                    setCurrValues={setFormState}
                    validationError={validationState?.price}
                    setValidationState={setValidationState}
                />
                <TextFieldValidation
                    select
                    name="currencyId"
                    label="Валюта"
                    value={formState?.currencyId}
                    setCurrValues={setFormState}
                >
                    {currencies?.map((option) => (
                        <MenuItem key={option.id} value={option.id}>
                            {option.curName}
                        </MenuItem>))}
                </TextFieldValidation>
            </DialogContent>
            <DialogActions sx={{p: '1.25rem'}}>
                <ButtonExit text={"Отменить"} onClick={handleClose}/>
                <ButtonAdd loading={loading} text={"Выбрать"} onClick={handleValidationData}/>
            </DialogActions>
        </Dialog>
    );
}

export default WarehouseMaterialItemTable;